<template>
  <BaseModal v-model="showModal" ref="modal">
    <form @submit.prevent="onSubmit">
      <label>
        ¿Esta seguro que desea eliminar el recurso:
        <b>{{resource?.name }}</b>
        ?
      </label>
      <br>
      <button type="submit" class="btn btn-danger mt-2" :disabled="processing">
        <b-spinner v-show="processing" small/>
        Eliminar
      </button>
    </form>
  </BaseModal>
</template>
<script>
import BaseModal from "@/components/shared/Base-modal.vue"
import {EventNames} from "@/plugins/enums/index.js"
import {mapActions} from "vuex"

export default {
  name: "ResourceDelete",

  components: {
    BaseModal,
  },

  data() {
    return {
      processing: false,
      showModal: false,
      resource: null,
      courseId: null,
    }
  },

  mounted() {
    this.$eventBus.$on(EventNames.OpenModalDeleteResource, ({resource, courseId}) => {
      this.resource = resource
      this.courseId = courseId
      this.showModal = true
    })
  },

  methods: {
    ...mapActions(["deleteResource"]),
    async onSubmit() {
      this.processing = true
      let result = await this.deleteResource({materialId: this.resource.id})

      if (result.isError) {
        this.$refs.modal.showAlert(result.message, "warning")
        this.processing = false
        return
      }

      this.$refs.modal.showAlertExternal("Recurso eliminado correctamente", "success")
      this.processing = false
      this.showModal = false
      this.resource = false
      this.$eventBus.$emit(EventNames.UpdateCurrentCurriculum, {courseId: this.courseId})
    }
  }
}
</script>